// extracted by mini-css-extract-plugin
export var divider = "_fr-7";
export var itemsToggle = "_fr-8";
export var mergeModal = "_fr-1";
export var optionCard = "_fr-4";
export var radioGroup = "_fr-6";
export var radioOption = "_fr-0";
export var selected = "_fr-5";
export var shipmentOptions = "_fr-2";
export var tableOptions = "_fr-3";